import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../../server/validationMethods.js'
import Draft from './draft.js';
import { personType } from './schoolLunchBreakfastModal.js';
class StudentsList extends Component {
    constructor(props){
        super(props);
        this.state={
            hasError:false
        }
        this.validateStudents=this.validateStudents.bind(this)
        this.childComponentRef = React.createRef();
    }
    validateStudents=()=>{
        console.log("studentList::::::::::",this.props.lunchObj.studentList);
         let someSelected=this.props.lunchObj.studentList.some(function (e) {
            return e.isSelected;
        });
        return someSelected
     }
render(){
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        {this.props.lunchObj.studentList.length > 0 ?
                        <p><strong><Trans>Select students from the household applying for school meal benefits</Trans></strong></p>
                        :<p className="text-center"><strong><Trans>All students related to this parent, filled application</Trans>.</strong></p>}
                    </div>
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-12">
                    <p>
                    {(!this.validateStudents() && this.state.hasError)? <span className="text-danger"> [<Trans>{'Please select atleast one student in the list'}</Trans>]</span>:null
                    }</p>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                <div className="styled-input-container styled-input--square">
                    <ul className="list-group">
                    {this.props.lunchObj.studentList.map((item,k)=>{
                            return <li key={'stud'+k} className="list-group-item" style={{padding:'7px 7px 0px 10px'}}>
                                        <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                            <input id={'stud'+k} checked={item.isSelected} data-idx={k} type='checkbox' onChange={(e)=>{
                                                let _idx=e.target.getAttribute('data-idx');
                                                this.props.onStudentSelectChange(_idx,e.target.checked?true:false);
                                                if(e.target.checked)
                                                    this.setState({hasError:false})
                                                this.childComponentRef.current.formatDraftReqObj();
                                            }} /> 
                                            <label htmlFor={'stud'+k}>
                                            {item.lname+', '+item.fname}</label>
                                         </div>
                                    </li>
                            })
                    }
                    </ul>
                    </div>
                </div>
            </div> 
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(2)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" disabled={this.props.lunchObj.studentList.length === 0} onClick={(e)=>{                       
                            if(!this.validateStudents()){
                                this.setState({hasError:true})
                            }else{
                                this.props.jumpToStep(4);
                                return true;
                            }
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} ref={this.childComponentRef} isDistrict={this.props.isDistrict}/>
                </div>
            </div>
        </div>
    )
}
}
export default StudentsList;


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/studentsList.jsx